module.exports = __webpack_public_path__ + "img/web-48.353c1d9b.jpg";